import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { TypePrice } from '@enumerates/types/type-price';

import { SubscriptionPlanVirtual } from '@models/user/subscription-info/subscription-plan-virtual';

import { HttpService } from '@services/http.service';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class VirtualInfoService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    private subscriptionSubject = new BehaviorSubject<Partial<SubscriptionPlanVirtual>>({ });
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);

    private dataStore: { subscriptionPlanVirtual: Partial<SubscriptionPlanVirtual> } = { subscriptionPlanVirtual: { } };

    readonly subscriptionPlanVirtual = this.subscriptionSubject.asObservable();
    readonly loadingData = this.isLoadingDataSubject.asObservable();

    search(): void {
        this.loading(true);
        this.getSubscription().subscribe(
            () => {
                this.next({ ...this.dataStore.subscriptionPlanVirtual });
                this.loading(false);
            }
        );
    }

    private getSubscription(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.get('fee/recurrentfee/member/virtual', this.defaultEndpointParams).subscribe(
                    data => {
                        this.dataStore.subscriptionPlanVirtual = data;
                        if (data && this.dataStore.subscriptionPlanVirtual.type != null) {
                            this.dataStore.subscriptionPlanVirtual.typeName = TypePrice[this.dataStore.subscriptionPlanVirtual.type];
                        }
                        observable.next(true);
                    },
                    () => observable.next(false)
                );
            }
        );
    }

    private next(data: Partial<SubscriptionPlanVirtual>): void {
        this.subscriptionSubject.next(data);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
